var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAutoPay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 65,
    viewBox: "0 0 56 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0736 28.866L50.757 34.1041L44.8401 39.9089L39.501 37.2758C39.501 37.2758 39.5001 37.2767 39.4992 37.2767C37.8087 38.2287 35.9835 38.978 34.0603 39.4893L32.1838 45.0509H23.8153L21.9397 39.4893C20.0138 38.978 18.1895 38.2287 16.4981 37.2767H16.4972L11.1599 39.9089L5.24205 34.1041L7.92554 28.8678C6.95405 27.2096 6.19107 25.4192 5.66983 23.5301L0 21.6903V17.5859H12.1206C12.1206 26.1879 19.2301 33.1617 27.9987 33.1617H27.9995C36.7699 33.1608 43.8785 26.1879 43.8785 17.5859H56V21.6903L50.3284 23.531C49.8071 25.4183 49.0441 27.2087 48.0736 28.866Z",
    fill: "#FFB257"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9413 17.586C45.9413 27.2985 37.9247 35.172 28.0356 35.172C18.1466 35.172 10.1299 27.2985 10.1299 17.586C10.1299 7.87351 18.1466 0 28.0356 0C37.9247 0 45.9413 7.87351 45.9413 17.586Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3757 5.18481L18.3337 8.08728C15.8535 10.5211 14.3168 13.8813 14.3168 17.5861H10.1299C10.1299 12.7483 12.1363 8.36134 15.3757 5.18481Z",
    fill: "#FFD31F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8701 17.5861H41.6831C41.6831 13.8813 40.1464 10.5211 37.6663 8.08728L40.6253 5.18481C43.8647 8.36234 45.8701 12.7483 45.8701 17.5861Z",
    fill: "#FFD31F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2192 10.9299L24.1834 13.8377C23.2038 14.7986 22.5983 16.1247 22.5983 17.586H18.405C18.405 14.9896 19.482 12.635 21.2202 10.9299H21.2192Z",
    fill: "#FFD31F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5939 17.586H33.4013C33.4013 16.1247 32.795 14.7986 31.8165 13.8377L34.7802 10.9299C36.5181 12.635 37.5949 14.9906 37.5949 17.586H37.5939Z",
    fill: "#FFD31F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6624 5.15637L37.6988 8.06547L27.9999 17.586L24.1786 13.8359L21.215 10.9268L18.3001 8.06547L15.3375 5.15637C18.582 1.97158 23.0603 0 27.9999 0C32.9396 0 37.4179 1.97258 40.6624 5.15637Z",
    fill: "#FFEFB2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6624 5.15116L37.6988 8.05733C35.2137 5.62044 31.7828 4.11118 27.9999 4.11118C24.2171 4.11118 20.7851 5.62044 18.3001 8.05733L15.3375 5.15116C18.582 1.96959 23.0603 0 27.9999 0C32.9396 0 37.4179 1.97058 40.6624 5.15116Z",
    fill: "#0577FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8127 10.8918L31.8523 13.8026C30.875 12.8406 29.5249 12.2451 28.0361 12.2451C26.5473 12.2451 25.1963 12.8416 24.2189 13.8026L21.2585 10.8918C22.9955 9.184 25.3927 8.12744 28.0361 8.12744C30.6795 8.12744 33.0768 9.184 34.8127 10.8918Z",
    fill: "#0577FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0005 17.5859L22.614 22.8407H28.0005H33.386L28.0005 17.5859Z",
    fill: "#091F83"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7464 22.8408H25.2534V27.8854H30.7464V22.8408Z",
    fill: "#0577FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAutoPay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AutoPay.f8d6776e0d837709bfa388c92b48fbab.svg";